import React from 'react';
import { mockData } from '../data/mockData';
import * as Icons from 'lucide-react';

const Process = () => {
  return (
    <section id="process" className="relative py-32 bg-black">
      <div className="max-w-[1400px] mx-auto px-[7.6923%]">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="display-large text-white mb-6">
            Our <span className="text-[#00FFD1]">Process</span>
          </h2>
          <p className="body-large text-white/85 max-w-3xl mx-auto">
            From initial consultation to final delivery, we ensure a seamless experience 
            in creating your professional virtual tour.
          </p>
        </div>

        {/* Process Timeline */}
        <div className="relative">
          {/* Vertical Line */}
          <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-[#00FFD1]/0 via-[#00FFD1]/50 to-[#00FFD1]/0" />

          {/* Process Steps */}
          <div className="space-y-16">
            {mockData.process.map((step, index) => {
              const IconComponent = Icons[step.icon];
              const isEven = index % 2 === 0;

              return (
                <div
                  key={index}
                  className={`relative flex items-center ${
                    isEven ? 'lg:flex-row' : 'lg:flex-row-reverse'
                  } flex-col gap-8`}
                >
                  {/* Content Card */}
                  <div className={`flex-1 ${isEven ? 'lg:text-right' : 'lg:text-left'} text-center`}>
                    <div className="inline-block p-8 bg-white/5 backdrop-blur-sm border border-white/10 hover:border-[#00FFD1]/50 hover:bg-white/10 transition-all duration-400">
                      <div className={`flex items-center gap-4 mb-4 ${isEven ? 'lg:flex-row-reverse' : 'lg:flex-row'} flex-row justify-center lg:justify-start`}>
                        <div className="w-16 h-16 bg-[#00FFD1]/10 flex items-center justify-center">
                          <IconComponent className="w-8 h-8 text-[#00FFD1]" />
                        </div>
                        <div>
                          <span className="text-[#00FFD1] text-sm font-semibold">Step {step.step}</span>
                          <h3 className="heading-2 text-white">{step.title}</h3>
                        </div>
                      </div>
                      <p className="body-medium text-white/70 max-w-lg">
                        {step.description}
                      </p>
                    </div>
                  </div>

                  {/* Center Circle */}
                  <div className="hidden lg:block absolute left-1/2 transform -translate-x-1/2 w-12 h-12 bg-black border-4 border-[#00FFD1] rounded-full flex items-center justify-center z-10">
                    <div className="w-4 h-4 bg-[#00FFD1] rounded-full animate-pulse" />
                  </div>

                  {/* Spacer */}
                  <div className="flex-1 hidden lg:block" />
                </div>
              );
            })}
          </div>
        </div>

        {/* Timeline Duration */}
        <div className="text-center mt-20 p-8 bg-white/5 backdrop-blur-sm border border-white/10">
          <p className="body-large text-white mb-2">
            <span className="text-[#00FFD1] font-semibold">Typical Timeline:</span> 5-7 Business Days
          </p>
          <p className="body-small text-white/70">
            Rush services available for urgent requirements
          </p>
        </div>
      </div>
    </section>
  );
};

export default Process;
